@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.content {
  display: flex;
  flex-direction: column;
  .linkHolder {
    color:  hevo-toolkit-variables.$light-text;
    word-break: break-word;
  }

  .scrollToTopButton {
    display: flex;
    align-items: center;
    white-space: pre;
  }

  &.warning {
    .linkHolder {
      color: var(--error-color);
    }
  }
}
